import React, { useState, useEffect } from 'react';
import './Gifts.css';
import { useLanguage } from '../../context/LanguageContext';
import productsData from '../../backend/data/productsData.json';

function Gifts() {
  const { t } = useLanguage();

  const [sortOrder, setSortOrder] = useState('none');
  const [categoryFilter, setCategoryFilter] = useState('all');
  const [products, setProducts] = useState(productsData.filter(p => p.name && p.price > 0)); // Initial fallback, filter out empty placeholders
  const [, setLoading] = useState(true);
  const [checkoutLoading, setCheckoutLoading] = useState(null); // Track which product is loading
  const [expandedCard, setExpandedCard] = useState(null); // Track which card is expanded

  // Modal state
  const [checkoutModal, setCheckoutModal] = useState(null);
  const [buyerName, setBuyerName] = useState('');
  const [buyerEmail, setBuyerEmail] = useState('');

  const API_URL = "https://esponjoboda.com";

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(`${API_URL}/api/products`);
        if (response.ok) {
          const data = await response.json();
          if (data.ok && data.products) {
            setProducts(data.products);
          }
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [API_URL]);



  const handleBuyGift = (productId) => {
    setCheckoutModal(productId);
  };

  const handleConfirmPurchase = async (e) => {
    e.preventDefault();
    if (!buyerName || !buyerEmail) return;

    setCheckoutLoading(checkoutModal);
    try {
      const response = await fetch(`${API_URL}/api/create-checkout-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          productId: checkoutModal,
          buyerName,
          buyerEmail
        })
      });

      const data = await response.json();
      if (data.ok && data.url) {
        window.location.href = data.url; // Redirect to Stripe
      } else {
        alert("Hubo un error al iniciar el pago. Intenta de nuevo más tarde.");
        setCheckoutLoading(null);
        setCheckoutModal(null);
      }
    } catch (error) {
      console.error("Error creating checkout session:", error);
      alert("Hubo un error de conexión.");
      setCheckoutLoading(null);
      setCheckoutModal(null);
    }
  };

  const sortedProducts = [...products].sort((a, b) => {
    if (sortOrder === 'asc') return a.price - b.price;
    if (sortOrder === 'desc') return b.price - a.price;
    return b.id - a.id; // 'none' — newest first
  });

  const filteredProducts = sortedProducts.filter(product => {
    if (categoryFilter === 'all') return true;
    return product.category === categoryFilter;
  });

  return (
    <div className="gifts-parent-container">
      <div className="gifts-section">
        <h2>{t.gift_title}</h2>
      </div>



      {/* Temporary Store Section */}
      <div className="temporary-store-section">
        <p className="store-subtitle">{t.gift_store_subtitle}</p>

        <div className="store-controls">
          <div className="control-group">
            <label htmlFor="category-select" className="sort-label">{t.gift_category_label}</label>
            <select
              id="category-select"
              className="sort-select"
              value={categoryFilter}
              onChange={(e) => setCategoryFilter(e.target.value)}
            >
              <option value="all">{t.gift_category_all}</option>
              <option value="Luna de Miel">{t.gift_category_honeymoon}</option>
              <option value="Electrónica">{t.gift_category_electronics}</option>
              <option value="Electrodomésticos">{t.gift_category_appliances}</option>
              <option value="Hogar">{t.gift_category_home}</option>
            </select>
          </div>

          <div className="control-group">
            <label htmlFor="sort-select" className="sort-label">{t.gift_sort_label}</label>
            <select
              id="sort-select"
              className="sort-select"
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
            >
              <option value="none">{t.gift_sort_none}</option>
              <option value="asc">{t.gift_sort_asc}</option>
              <option value="desc">{t.gift_sort_desc}</option>
            </select>
          </div>
        </div>

        <div className="products-grid">
          {filteredProducts.map(product => {
            const isExpanded = expandedCard === product.id;
            return (
              <div
                key={product.id}
                className={`product-card ${!product.available ? 'sold-out' : ''} ${isExpanded ? 'expanded' : ''}`}
                onClick={() => setExpandedCard(isExpanded ? null : product.id)}
              >
                <div className="product-image-container">
                  <img src={product.image} alt={product.name} className="product-image" loading="lazy" />
                  {!product.available && <div className="sold-out-overlay">{t.gift_sold_out}</div>}
                </div>
                <div className="product-details">
                  <h4 className="product-name">{product.name}</h4>
                  <span className="product-price">${product.price.toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} <span className="price-currency">MXN</span></span>
                  <div className={`product-expandable ${isExpanded ? 'show' : ''}`}>
                    <p className="product-description">{product.description}</p>
                    <div className="product-footer">
                      <button
                        className="buy-gift-button"
                        onClick={(e) => { e.stopPropagation(); handleBuyGift(product.id); }}
                        disabled={!product.available || checkoutLoading === product.id}
                      >
                        {!product.available
                          ? t.gift_sold_out
                          : checkoutLoading === product.id
                            ? t.gift_processing
                            : t.gift_buy_button}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {checkoutModal && (
        <div className="checkout-modal-overlay">
          <div className="checkout-modal">
            <h3>{t.gift_modal_title}</h3>
            <p className="secure-payment-notice">
              {t.gift_modal_secure}
            </p>
            <form onSubmit={handleConfirmPurchase}>
              <div className="checkout-form-group">
                <label htmlFor="buyerName">{t.gift_modal_name}</label>
                <input
                  type="text"
                  id="buyerName"
                  required
                  value={buyerName}
                  onChange={(e) => setBuyerName(e.target.value)}
                  placeholder={t.gift_modal_name_placeholder}
                />
              </div>
              <div className="checkout-form-group">
                <label htmlFor="buyerEmail">{t.gift_modal_email}</label>
                <input
                  type="email"
                  id="buyerEmail"
                  required
                  value={buyerEmail}
                  onChange={(e) => setBuyerEmail(e.target.value)}
                  placeholder={t.gift_modal_email_placeholder}
                />
              </div>
              <div className="checkout-modal-actions">
                <button
                  type="button"
                  className="btn-modal-cancel"
                  onClick={() => setCheckoutModal(null)}
                  disabled={checkoutLoading === checkoutModal}
                >
                  {t.gift_modal_cancel}
                </button>
                <button
                  type="submit"
                  className="btn-modal-confirm"
                  disabled={checkoutLoading === checkoutModal}
                >
                  {checkoutLoading === checkoutModal ? t.gift_processing : t.gift_modal_continue}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

    </div>
  );
}

export default Gifts;